import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { EvaluatorSidebar } from "@/project/karuna/components/evaluator/EvaluatorSidebar"; // @ts-ignore - EvaluatorSidebar is not a valid module
import {
  SidebarProvider,
  SidebarTrigger,
} from "@/project/karuna/components/ui/sidebar"; // @ts-ignore - sidebar is not a valid module
import { Bell, MessageSquare } from "lucide-react";
import { Button } from "@/project/karuna/components/ui/button"; // @ts-ignore - button is not a valid module
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/project/karuna/components/ui/dropdown-menu"; // @ts-ignore - dropdown-menu is not a valid module
import { Avatar, AvatarFallback } from "@/project/karuna/components/ui/avatar"; // @ts-ignore - avatar is not a valid module
import { supabase } from "@/project/karuna/integrations/supabase/client"; // @ts-ignore - supabase is not a valid module

interface EvaluatorLayoutProps {
  children: ReactNode;
}

export function EvaluatorLayout({ children }: EvaluatorLayoutProps) {
  const navigate = useNavigate();

  // DEMO MODE: Authentication check disabled for client presentation
  // useEffect(() => {
  //   if (!user) {
  //     navigate("/");
  //   } else if (userRole !== "evaluator") {
  //     navigate("/");
  //   }
  // }, [user, userRole, navigate]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/");
  };

  // DEMO MODE: Removed authentication guard for client presentation
  // if (!user || userRole !== "evaluator") {
  //   return null;
  // }

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-background">
        <EvaluatorSidebar />
        <div className="flex flex-1 flex-col">
          <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <div className="container flex h-16 items-center justify-between px-4">
              <SidebarTrigger />

              <div className="flex items-center gap-4">
                <Button variant="ghost" size="icon">
                  <Bell className="h-5 w-5" />
                </Button>
                <Button variant="ghost" size="icon">
                  <MessageSquare className="h-5 w-5" />
                </Button>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      variant="ghost"
                      className="relative h-10 w-10 rounded-full"
                    >
                      <Avatar className="h-10 w-10">
                        <AvatarFallback className="bg-primary text-primary-foreground">
                          EV
                        </AvatarFallback>
                      </Avatar>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={handleLogout}>
                      Logout
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </div>
          </header>
          <main className="container flex-1 px-4 py-6">{children}</main>
        </div>
      </div>
    </SidebarProvider>
  );
}
